import InformationFlow from './informationFlow';
import SingleTitle from './informationFlow/components/singleTitle';
import TitleImg from './informationFlow/components/titleImg';
import BigImg from './informationFlow/components/bigImg';
import BigTopic from './informationFlow/components/bigTopic';
import SlideImg from './informationFlow/components/slideImg';
import TwoImg from './informationFlow/components/twoImg';

export { InformationFlow, SingleTitle, TitleImg, BigImg, BigTopic, SlideImg, TwoImg };
